module.exports = __webpack_public_path__ + "static/storytimePodcast-02cba9f6a41060ac9dd7f066c8d1a5e4.jpg";